<template>
    <nav
        class="flex items-center text-sm text-gray-400"
        aria-label="Breadcrumb"
    >
        <!-- Ikona – Domains -->
        <div class="flex items-center">
            <Globe class="h-4 w-4 mr-1" />
            <span>Domains</span>
        </div>

        <!-- Folder (pokud je) -->
        <template v-if="source">
            <span class="mx-2 text-gray-300">></span>
            <span>Nazev folderu (pokud je)</span>
        </template>

        <!-- Doména -->
        <span class="mx-2 text-gray-300">></span>
        <span class="text-gray-600 font-medium">{{ domain }}</span>
    </nav>
</template>

<script setup lang="ts">
import { Globe } from "lucide-vue-next";

defineProps<{
    domain: string;
    source?: string | null; // folder name simulovaný přes „source“
}>();
</script>
